export default "__VITE_ASSET__IAKR$N3B__"